<template>
    <v-snackbar
        v-model="isOpen"
        :timeout="timeout"
        :color="snackColor"
        @input="$emit('close')"
    >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
            <v-btn
                v-bind="attrs"
                text
                @click="$emit('close')"
            >
                {{ $t('close') }}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
    export default {
        name: 'EditSnackbar',
        model: {
            prop: 'isOpen',
            event: 'input'
        },
        props: {
            isOpen: {
                required: true,
                type: Boolean
            },
            snackColor: {
                required: false,
                type: String,
                default: 'info',
            },
            snackText: {
                required: false,
                type: String,
                default: '',
            },
            timeout: {
                required: false,
                type: Number,
                default: 3000,
            },
        },
    }
</script>

<style scoped>

</style>
